import {MY_WORK_CONFIG} from "./views/my-work";
import PersonalView from "./personal-view";
import {NOTIFICATIONS_CONFIG} from "./views/notifications";
import {MY_RECENT_CONFIG} from "./views/my-recent";
import {PersonalViewLocation} from "./@types";
import {MY_TIME_CONFIG} from "./views/my-time";
import {MY_TASKS_LIST_CONFIG} from "./views/my-tasks-list";
import ArrayUtils from "../../../gd/utils/array";
import {MY_WORK_WORKLOAD_CONFIG} from "./views/my-work-workload";
import {MY_DOCUMENTS_CONFIG} from "./views/my-documents";
import {MY_GOALS_CONFIG} from "./views/my-goals";
import {MY_WORK_CALENDAR_CONFIG} from "./views/my-work-calendar";
import {MY_MEETINGS_CONFIG} from "./views/my-meetings";
import {MY_NOTES_CONFIG} from "./views/my-notes";
import {MY_ATTENDANCE_CONFIG} from "./views/my-attendance";


export default class PersonalViews {


    public myWork           : PersonalView = new PersonalView(MY_WORK_CONFIG)
    public notifications    : PersonalView = new PersonalView(NOTIFICATIONS_CONFIG)
    public recent           : PersonalView = new PersonalView(MY_RECENT_CONFIG)
    public myTasks          : PersonalView = new PersonalView(MY_TASKS_LIST_CONFIG)
    public myTime           : PersonalView = new PersonalView(MY_TIME_CONFIG)

    public myWorkload       : PersonalView = new PersonalView(MY_WORK_WORKLOAD_CONFIG)
    public documents        : PersonalView = new PersonalView(MY_DOCUMENTS_CONFIG)
    public goals            : PersonalView = new PersonalView(MY_GOALS_CONFIG)
    public calendar         : PersonalView = new PersonalView(MY_WORK_CALENDAR_CONFIG)
    public meetings         : PersonalView = new PersonalView(MY_MEETINGS_CONFIG)
    public notes            : PersonalView = new PersonalView(MY_NOTES_CONFIG)
    public attendance       : PersonalView = new PersonalView(MY_ATTENDANCE_CONFIG)

    constructor() {

    }

    private filter(position: PersonalViewLocation):PersonalView[] {
        const views : PersonalView[] = []

        const availableViews = _.compact([
            this.myWork,
            this.myTasks,
            this.myTime,
            this.myWorkload,
            this.documents,
            gd.modules.goals.enabled ? this.goals : null,
            this.calendar,
            gd.modules.meetings.enabled ? this.meetings : null,
            this.notes,
            gd.modules.clockInOut.enabled ? this.attendance : null,
            this.notifications,
            this.recent
        ])

        _.each(availableViews,
            (view)=>{
                if (view.location===position) {
                    views.push(view)
                }
            })

        return views
    }

    get homeViews():PersonalView[] {
         let views = this.filter(PersonalViewLocation.HOME)

        // apply sorting
        views = _(views)
            .orderBy([
                view=>ArrayUtils.indexOrder(gd.user.menu.myWork.sortPositions, view.id), // try to order by sort position
                view=>ArrayUtils.indexOrder(['my-work', 'notifications'], view.id), // try to order default menu items
            ], ['asc','asc'])
            .value();

        return views
    }

    get homeMoreViews():PersonalView[] {
        return this.filter(PersonalViewLocation.HOME_MORE)
    }

    get hasMoreViews() {
        return !_.isEmpty(this.homeMoreViews)
    }

    get navigationPanelViews():PersonalView[] {
        return this.filter(PersonalViewLocation.NAVIGATION_PANEL)
    }

    get isMoreViewSelected(): boolean {
        return _.some(this.homeMoreViews, (view)=>view.isOpen())
    }

    // get(type:ViewType):PersonalView {
    //
    //     switch (type) {
    //         case ViewType.MY_RECENT         : return this.recent;
    //         case ViewType.NOTIFICATIONS     : return this.notifications;
    //         case ViewType.MY_WORK           : return this.myWork;
    //
    //         default:
    //             throw new Error("#djkdhu89 - unknown type '" + type + "'");
    //     }
    // }


}